import { LOGISTICS_DATAS } from "../../constants";
import { formatDeliveryAddress } from "../../helpers";

//* ທີ່ຢູ່ປາຍທາງ ສຳລັບພິມບິນ — ໃຊ້ຮ່ວມກັນທຸກແບບບິນ
//*   1. ມີ orderDelivery (ລູກຄ້າເລືອກຂົນສົ່ງ / ຈອງແລ້ວ) → "ສາຂາ, ເມືອງ, ແຂວງ" ຈາກ receiver
//*   2. ບໍ່ມີ → addressCf (ທີ່ຢູ່ທີ່ພິມ ຫຼື ເລືອກໃນໜ້າສ້າງອໍເດີ) → destinationLogistic
export const billDestination = (item) => {
  const fromDelivery = item?.orderDelivery?.id
    ? formatDeliveryAddress(item?.orderDelivery?.receiver)
    : "";
  return fromDelivery || item?.addressCf || item?.destinationLogistic || "";
};

//* ຊື່ຂົນສົ່ງ ສຳລັບພິມບິນ — ຈາກ orderDelivery ກ່ອນ, ບໍ່ມີ → ຊື່ທີ່ບັນທຶກໃນອໍເດີ (logistic)
//*   "ພິມທີ່ຢູ່ເອງ" ບໍ່ແມ່ນຊື່ຂົນສົ່ງ → ບໍ່ສະແດງ
export const billLogistic = (item) => {
  const key = item?.orderDelivery?.delivery;
  const fromDelivery = key ? LOGISTICS_DATAS?.[String(key).toLowerCase()]?.name || key : "";
  const name = fromDelivery || item?.logistic || "";
  return name === "ພິມທີ່ຢູ່ເອງ" || name === item?.addressCf ? "" : name;
};

//* ແຖວ "ທີ່ຢູ່" ຂອງຜູ້ຮັບ ໃນບິນຂົນສົ່ງ (ມີແຖວ "ສາຂາ" ແຍກຢູ່ແລ້ວ) → ບ້ານ, ເມືອງ, ແຂວງ ບໍ່ຊ້ຳສາຂາ
//*   ບໍ່ມີ orderDelivery → ໃຊ້ທີ່ຢູ່ໃນອໍເດີ (addressCf)
export const billReceiverAddress = (item) => {
  const r = item?.orderDelivery?.id ? item?.orderDelivery?.receiver : null;
  const fromDelivery = r ? [r.village, r.district, r.province].filter(Boolean).join(", ") : "";
  return fromDelivery || item?.addressCf || item?.destinationLogistic || "";
};

//* ທີ່ຢູ່ຕົ້ນທາງ (ຜູ້ສົ່ງ) ສຳລັບພິມບິນ — ບ້ານ, ເມືອງ, ແຂວງ
//*   1. ມີ orderDelivery → ທີ່ຢູ່ຜູ້ສົ່ງທີ່ໃຊ້ຈອງຂົນສົ່ງ (sender)
//*   2. ບໍ່ມີ → ທີ່ຢູ່ຂອງຮ້ານ (shopData.address ຈາກ query SHOP)
export const billSenderAddress = (item, shopData) => {
  const join = (a) => [a?.village, a?.district, a?.province].filter(Boolean).join(", ");
  const fromDelivery = item?.orderDelivery?.id ? join(item?.orderDelivery?.sender) : "";
  return fromDelivery || join(shopData?.address) || "";
};
